import { create } from 'zustand';
import { useTaskStore } from '@/stores/taskStore';
import type { Task } from '@/types';

interface EditorOpenState {
  openTaskId: string | null;
  openEditor: (id: string) => void;
  closeEditor: () => void;
}

export const useEditorOpenStore = create<EditorOpenState>()((set) => ({
  openTaskId: null,
  openEditor: (id) => set({ openTaskId: id }),
  closeEditor: () => set({ openTaskId: null }),
}));

export interface UseEditorOpenResult {
  open: boolean;
  task: Task | null;
  closeEditor: () => void;
}

export function useEditorOpen(): UseEditorOpenResult {
  const openTaskId = useEditorOpenStore((s) => s.openTaskId);
  const closeEditor = useEditorOpenStore((s) => s.closeEditor);
  const task = useTaskStore((s) =>
    openTaskId ? (s.tasks.find((t) => t.id === openTaskId) ?? null) : null,
  );
  return {
    open: openTaskId !== null && task !== null,
    task,
    closeEditor,
  };
}
